// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';
import {
  useDisableClusterWorkloadMutation,
  useEnableClusterWorkloadMutation,
} from '@streaming-projects/service-definitions/streamingProjectsApi';
import { CLUSTER_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { CheckBoxField } from '@src/formik-utils/FormFields';
import { toastError } from '@presentational/notifications/utils';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';

import { CLUSTER_WORKLOAD_DETAILS_CONFIG_MAP } from '../config';

export const SPClusterWorkloadEnabledContainer = ({
  clusterWorkloadId = null,
  clusterResourceId = null,
  checked = null,
  addLabel = true,
}) => {
  const { orgId, spId } = useParams();
  const { isValid } = useFormikContext();
  const spStreamingProjectData = useContext(SPStreamingProjectContext);

  const [enableClusterWorkload] = useEnableClusterWorkloadMutation();
  const [disableClusterWorkload] = useDisableClusterWorkloadMutation();

  const { backendFieldName, displayName, icon } = CLUSTER_WORKLOAD_DETAILS_CONFIG_MAP.get(
    CLUSTER_WORKLOADS_INPUTS_FIELDNAMES.IS_ENABLED
  );

  const checkedProps = checked != null ? { checked } : {};
  return (
    <CheckBoxField
      addLabel={addLabel}
      disabled={!isValid}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      icon={icon}
      onChange={async (event, value, setFieldValue, setFieldTouched, values, checked) => {
        const payload = {
          cluster_resource_id: clusterResourceId,
          sp_version: spStreamingProjectData?.sp?.version,
        };

        const funcToCall = checked ? enableClusterWorkload : disableClusterWorkload;

        const { error } = await funcToCall({
          orgId,
          spId,
          clusterWorkloadId,
          payload,
        });

        if (error) {
          toastError(error);
        }
      }}
      {...checkedProps}
    />
  );
};
